<template>
  <div id="app">
    <loading v-if="$store.state.loading"> </loading>
    <router-view v-else/>
    <p v-for="error in $root.errors">{{error.message}}</p>
  </div>
</template>

<script>
  import Loading from '@/layouts/Loading'
  export default {
    components: {Loading}
  }
</script>

<style lang="scss">
#app {
  font-family: 'Proxima Nova', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
  font-size: 16px;
  font-variant-numeric: tabular-nums lining-nums;

  @media print {
    font-size: 12px;
  }
}
  html, body {
    display: block;
    margin: 0;
    padding: 0;
  }

  body {
    max-width: 1240px;
    margin: 0 auto;
    overflow-y: scroll;
  }

  .number-font {
    font-family: 'Proxima Nova', Helvetica, Arial, sans-serif;
    font-feature-settings: "tnum" on;
    text-align: right;
  }
</style>

<style lang="sass">
  div.form
    display: block
    border: 1px solid #b8b8b8
    border-color: inherit
    font-weight: bold
    font-size: 1.5em

    div.form-field-group
      display: flex
      border-color: inherit
      justify-content: flex-end
      flex-wrap: wrap


    div.form-field
      display: block
      border: 1px solid #b8b8b8
      border-color: inherit
      padding: 0.5em
      flex-grow: 1
      flex-basis: 200px
      box-sizing: border-box

    label
      display: block
      text-transform: uppercase
      font-weight: 500
      margin: 0 0 0.5em 0
      color: #b8b8b8
      font-size: 0.5em

    button
      margin: 0

  input, textarea
    display: block
    font: inherit
    box-sizing: border-box
    border: 0
    color: inherit
    flex-grow: 1
    flex-basis: 200px
    border-radius: 4px
    padding: 0.5em
    background: rgba(0, 0, 0, 0.05)
    appearance: none

    &:focus
      background: transparent

    /* weird fixes, otherwise overflow on mobile sizes */
    min-width: 150px
    width: 100%

  .input-flex
    display: flex
    align-items: flex-start
    flex-wrap: wrap
    justify-content: space-between
</style>